/**
 * Chip — v4 small inline tag (brand tags, filters, meta).
 * Accepts a `color` to tint the text (e.g. brand colors).
 */

import type { CSSProperties, ReactNode } from 'react';

export interface ChipProps {
  children: ReactNode;
  /** Text color override (any CSS color). */
  color?: string;
  icon?: ReactNode;
  className?: string;
  style?: CSSProperties;
}

export function Chip({ children, color, icon, className, style }: ChipProps) {
  const classes = ['v4-chip', className ?? ''].filter(Boolean).join(' ');
  return (
    <span className={classes} style={{ ...(color ? { color } : null), ...style }}>
      {icon}
      {children}
    </span>
  );
}

export default Chip;
